// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ErrorBoundary_wrapper__A1Rbm"};